import React from 'react';
import { IAppLoadingSpinnerProps } from './IAppLoadingSpinnerProps';
import styles from './AppLoadingSpinner.module.scss';
import PulseLoader from 'react-spinners/PulseLoader';

const AppLoadingSpinner: React.FC<IAppLoadingSpinnerProps> = (props) => {
  const { loaderSize } = props;
  return (
    <div className={styles.container}
    >
        <PulseLoader
        color="#888888"
        size={loaderSize? loaderSize : 10}
        />
    </div>
  )
}

export default AppLoadingSpinner;